import {FormProvider, useForm} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {SpecialPriceIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {hitUserSegmentBudget} from "@pg-mono/google-tag-manager";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {BudgetFieldsNames} from "../../real_estate/types/BudgetFieldsNames";
import {convertToBudgetFilterDefaultValues} from "../../real_estate/utils/convert_to_budget_filter_default_values";
import {FilterBudget} from "../../search/components/generic_filters/FilterBudget";
import {useHitSearchSubmit} from "../../search/hooks/use_hit_search_submit";
import {useSearchFormSubmit} from "../../search/hooks/use_search_form_submit";
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {hitGtmFilterBudgetInBox} from "../tracking/listing_box_events";

const fieldNames = {
    radio: "budgetFilterBox" + BudgetFieldsNames.RADIO,
    credit: "budgetFilterBox" + BudgetFieldsNames.CREDIT,
    total: "budgetFilterBox" + BudgetFieldsNames.TOTAL
} as const;

type IDefaultOfferFormValues = {
    [K in keyof typeof fieldNames as (typeof fieldNames)[K]]: K extends "radio" ? string : number;
};

export const BudgetFilterBox = () => {
    const offerListLatestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues) as SearchFormValuesType;
    const hitSearchSubmit = useHitSearchSubmit();

    const budgetDefaults = convertToBudgetFilterDefaultValues(searchFormValues, "max");

    const defaultValues: IDefaultOfferFormValues = {
        [fieldNames.total]: budgetDefaults[BudgetFieldsNames.TOTAL],
        [fieldNames.credit]: budgetDefaults[BudgetFieldsNames.CREDIT],
        [fieldNames.radio]: budgetDefaults[BudgetFieldsNames.RADIO]
    };

    const formMethods = useForm({
        defaultValues
    });

    const submitSearchForm = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: offerListLatestQuery,
        listFriendlyLink: rpAppLink.offer.listFriendly,
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
        onSearchSubmit: (formValues) => {
            hitSearchSubmit(formValues);
        }
    });

    const onSubmit = async (values: typeof defaultValues) => {
        const instalment = values[fieldNames.credit];
        const budget = values[fieldNames.total];
        const selectedFilter = values[fieldNames.radio];

        const newFormValues = {
            ...searchFormValues,
            ...(selectedFilter === "total" ? {price: {lower: "", upper: budget}, instalment: ""} : {price: {lower: "", upper: ""}, instalment: instalment})
        };

        hitUserSegmentBudget({priceUpper: newFormValues.price?.upper, instalment: newFormValues.instalment});
        hitGtmFilterBudgetInBox(selectedFilter === "monthly");

        await submitSearchForm(newFormValues);
    };

    return (
        <OfferBoxBase className={css({minHeight: "450px"})}>
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmit)} className={formStyle}>
                    <div className={headerStyle}>
                        <SpecialPriceIcon size="3.2" wrapperSize="4.8" wrapperColor={getThemeVariable("colors.primary")} />

                        <Text as="p" variant="headline_5" align="center">
                            Podaj swój budżet, aby zobaczyć lepiej dopasowane oferty
                        </Text>
                    </div>

                    <FilterBudget inputVariant="column" fieldNames={fieldNames} />

                    <Button className={css({width: "100%"})} variant="outlined_secondary" type="submit">
                        Wybierz
                    </Button>
                </form>
            </FormProvider>
        </OfferBoxBase>
    );
};

const formStyle = css({
    height: "100%",
    width: "100%",
    paddingX: 3,
    paddingY: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column"
});

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2
});
import {FormProvider, useForm} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {SpecialPriceIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {hitUserSegmentBudget} from "@pg-mono/google-tag-manager";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {BudgetFieldsNames} from "../../real_estate/types/BudgetFieldsNames";
import {convertToBudgetFilterDefaultValues} from "../../real_estate/utils/convert_to_budget_filter_default_values";
import {FilterBudget} from "../../search/components/generic_filters/FilterBudget";
import {useHitSearchSubmit} from "../../search/hooks/use_hit_search_submit";
import {useSearchFormSubmit} from "../../search/hooks/use_search_form_submit";
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {hitGtmFilterBudgetInBox} from "../tracking/listing_box_events";

const fieldNames = {
    radio: "budgetFilterBox" + BudgetFieldsNames.RADIO,
    credit: "budgetFilterBox" + BudgetFieldsNames.CREDIT,
    total: "budgetFilterBox" + BudgetFieldsNames.TOTAL
} as const;

type IDefaultOfferFormValues = {
    [K in keyof typeof fieldNames as (typeof fieldNames)[K]]: K extends "radio" ? string : number;
};

export const BudgetFilterBox = () => {
    const offerListLatestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues) as SearchFormValuesType;
    const hitSearchSubmit = useHitSearchSubmit();

    const budgetDefaults = convertToBudgetFilterDefaultValues(searchFormValues, "max");

    const defaultValues: IDefaultOfferFormValues = {
        [fieldNames.total]: budgetDefaults[BudgetFieldsNames.TOTAL],
        [fieldNames.credit]: budgetDefaults[BudgetFieldsNames.CREDIT],
        [fieldNames.radio]: budgetDefaults[BudgetFieldsNames.RADIO]
    };

    const formMethods = useForm({
        defaultValues
    });

    const submitSearchForm = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: offerListLatestQuery,
        listFriendlyLink: rpAppLink.offer.listFriendly,
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
        onSearchSubmit: (formValues) => {
            hitSearchSubmit(formValues);
        }
    });

    const onSubmit = async (values: typeof defaultValues) => {
        const instalment = values[fieldNames.credit];
        const budget = values[fieldNames.total];
        const selectedFilter = values[fieldNames.radio];

        const newFormValues = {
            ...searchFormValues,
            ...(selectedFilter === "total" ? {price: {lower: "", upper: budget}, instalment: ""} : {price: {lower: "", upper: ""}, instalment: instalment})
        };

        hitUserSegmentBudget({priceUpper: newFormValues.price?.upper, instalment: newFormValues.instalment});
        hitGtmFilterBudgetInBox(selectedFilter === "monthly");

        await submitSearchForm(newFormValues);
    };

    return (
        <OfferBoxBase className={css({minHeight: "450px"})}>
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmit)} className={formStyle}>
                    <div className={headerStyle}>
                        <SpecialPriceIcon size="3.2" wrapperSize="4.8" wrapperColor={getThemeVariable("colors.primary")} />

                        <Text as="p" variant="headline_5" align="center">
                            Podaj swój budżet, aby zobaczyć lepiej dopasowane oferty
                        </Text>
                    </div>

                    <FilterBudget inputVariant="column" fieldNames={fieldNames} />

                    <Button className={css({width: "100%"})} variant="outlined_secondary" type="submit">
                        Wybierz
                    </Button>
                </form>
            </FormProvider>
        </OfferBoxBase>
    );
};

const formStyle = css({
    height: "100%",
    width: "100%",
    paddingX: 3,
    paddingY: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column"
});

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2
});
